import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

export const portalLoginDialogSelector = createSelector(
  [(state: RootState) => state.portalLoginDialog],
  ({ isOpen }) => {
    return { isOpen };
  },
);
